import api from "./../api"; 
import { useCallback } from "react";

export const useEgresoINMOB = () => {

  const getEgresos = async () => {
    try {
      const { data } = await api.get("/inmobiliaria/inmobiliaria/all/egresos");
      return data;
    } catch (error) {
      console.error("Error al traer egresos:", error);
      throw error.response?.data?.message || "Error al cargar egresos";
    }
  };

   const crearEgreso = async (nuevoEgreso) => {
    try {
      const { data } = await api.post(`/inmobiliaria/inmobiliaria/crear/egresos`, nuevoEgreso);
      return data;
    } catch (error) {
      console.error("💥 Error al crear egreso:", error);
      throw error.response?.data?.message || "Error al crear egreso";
    }
  };

  const editarEgreso = async (id, formData) => {
  try {
    const { data } = await api.post(`/inmobiliaria/inmobiliaria/editar/egresos/${id}`, formData);
    return data;
  } catch (error) {
    console.error("💥 Error al editar egreso:", error);
    throw error.response?.data || error;
  }
};

 const eliminarEgreso = async (id) => {
    try {
      const { data } = await api.delete(`/inmobiliaria/inmobiliaria/eliminar/egresos/${id}`);
      return data;
    } catch (error) {
      console.error("💥 Error al eliminar egreso:", error);
      throw error.response?.data?.message || "Error al eliminar egreso";
    }
  };

   const getCategoriaEgresos = async () => {
    try {
      const { data } = await api.get("/inmobiliaria/categoria/all/egresos");
      return data;
    } catch (error) {
      console.error("Error al traer egresos:", error);
      throw error.response?.data?.message || "Error al cargar egresos";
    }
  };
   const crearCategoriaEgresos = async (nuevoCategoriaEgreso) => {
    try {
      const { data } = await api.post(`/inmobiliaria/categoria/crear/egresos`, nuevoCategoriaEgreso);
      return data;
    } catch (error) {
      console.error("💥 Error al crear egreso:", error);
      throw error.response?.data?.message || "Error al crear egreso";
    }
  };

  const editarCategoriaEgresos = async (id, formData) => {
  try {
    const { data } = await api.put(`/inmobiliaria/categoria/editar/egresos/${id}`, formData);
    return data;
  } catch (error) {
    console.error("💥 Error al editar egreso:", error);
    throw error.response?.data || error;
  }
};

 const eliminarCategoriaEgresos = async (id) => {
    try {
      const { data } = await api.delete(`/inmobiliaria/categoria/eliminar/egresos/${id}`);
      return data;
    } catch (error) {
      console.error("💥 Error al eliminar egreso:", error);
      throw error.response?.data?.message || "Error al eliminar egreso";
    }
  };

  const getProveedorInmobiliaria = useCallback(async () => {
    const { data } = await api.get("/inmobiliaria/proveedor/all/egresos");
    return data;
  }, []);
  
    const crearProveedorInmobiliaria = async (payload) => {
      const { data } = await api.post(
        "/inmobiliaria/proveedor/crear/egresos",
        payload
      );
      return data;
    };
  
    const editarProveedorInmobiliaria = async (id, payload) => {
      const { data } = await api.put(
        `/inmobiliaria/proveedor/editar/egresos/${id}`,
        payload
      );
      return data;
    };
  
    const eliminarProveedorInmobiliaria = async (id) => {
      const { data } = await api.delete(
        `/inmobiliaria/proveedor/eliminar/egresos/${id}`
      );
      return data;
  };
   const getexcel = useCallback(async (mes, anio) => {
  try {
    const response = await api.get(
      "/inmobiliaria/egresos-inmobiliaria/export",
      {
        params: { mes, anio }, 
        responseType: "blob", 
      }
    );

    return response;
  } catch (error) {
    console.error("Error al descargar excel:", error);
    throw error;
  }
}, []);

 const getfiltromeses = useCallback(async () => {
  const { data } = await api.get("/inmobiliaria/egresos-inmobiliaria/meses");
  return data;
}, []);
  
const getfiltromesesyaño = useCallback(async (mes, anio) => {
  const { data } = await api.get(
    "/inmobiliaria/egresos-inmobiliaria/filtro",
    {
      params: { mes, anio }
    }
  );
  return data;
}, []);

  const descargarPdfEgreso = async (expenseId) => {
  try {

    const response = await api.get(
      `/inmobiliaria/descargar-pdf/egreso/${expenseId}`,
      {
        responseType: "blob"
      }
    );

    const blob = new Blob(
      [response.data],
      { type: "application/pdf" }
    );

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;
    link.setAttribute("download", `egreso_${expenseId}.pdf`);

    document.body.appendChild(link);

    link.click();

    link.remove();

    window.URL.revokeObjectURL(url);

  } catch (error) {

    console.error("Error al descargar PDF:", error);

    alert("No se pudo descargar el documento");
  }
};

  return {
    getEgresos,
    crearEgreso,
    editarEgreso,
    eliminarEgreso,
    getCategoriaEgresos,
    crearCategoriaEgresos,
    editarCategoriaEgresos,
    eliminarCategoriaEgresos,
    getProveedorInmobiliaria,
    crearProveedorInmobiliaria,
    editarProveedorInmobiliaria,
    eliminarProveedorInmobiliaria,
    /* get */
    getexcel,
    getfiltromeses,
    getfiltromesesyaño,
    descargarPdfEgreso 

  };
}
